import { useSyncExternalStore } from 'react';

export const DESKTOP_BREAKPOINT = 960;

const MEDIA_QUERY = `(min-width: ${DESKTOP_BREAKPOINT}px)`;

// `useSyncExternalStore` lets us derive `isDesktop` directly from the
// matchMedia subscription — no setState-in-effect, no layout-thrash on
// initial render.
function subscribeMql(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const mql = window.matchMedia(MEDIA_QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

function getMqlSnapshot(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(MEDIA_QUERY).matches;
}

function getMqlServerSnapshot(): boolean {
  return false;
}

export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribeMql, getMqlSnapshot, getMqlServerSnapshot);
}
